import { useQuery } from "@tanstack/react-query";
import { array, object, string } from "yup";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { smsSnippetSchema } from "./schemas";
import { removeNullishFromShape } from "../../utilities/general";
import { smsSnippetAdapter } from "./utilities";

const requestSchema = object({
  name: string().nullable(),
});

const responseSchema = array().of(smsSnippetSchema).required();

const composeResponse = (res) => {
  return res?.data?.data?.map(smsSnippetAdapter);
};

export const useSmsSnippetsQuery = (payload, options = {}) => {
  const req = requestSchema.validateSync(payload, {
    strict: true,
  });

  return useQuery({
    queryKey: [QUERY_KEYS.smsSnippets.all, req.name],
    queryFn: async () => {
      const res = await http.get(HTTP_ENDPOINTS.smsSnippets.getAll(), {
        params: removeNullishFromShape({
          name: req.name || null,
        }),
      });
      return responseSchema.validateSync(composeResponse(res, req), {
        strict: true,
      });
    },
    ...options,
  });
};
